<template>
    <div class="callback-container">
      <el-card>
        <h3>Processing your login...</h3>
      </el-card>
    </div>
  </template>
  
  <script setup>
  import { onMounted } from "vue";

  import { useRouter } from "vue-router";
  import { ElMessage } from "element-plus";
  import axiosInstance from "@/api/axios";
  import { useUserStore } from "@/stores/user";
  
  const router = useRouter();
  const userStore = useUserStore();
  
  // Query 파라미터에서 인증 코드 추출
  const route = router.currentRoute.value;
  const code = route.query.code;
  

  onMounted(async()=>{

      if (code) {

        try {
        
        console.log("code=",code)

          // 서버에 인증 코드 전달 후 액세스 토큰 요청
          const response = await axiosInstance.post("oauth/kakao/", { code });
          
        console.log("response.data=",response.data)

          // 토큰 저장
          localStorage.setItem("access_token", response.data.access_token);
          localStorage.setItem("refresh_token", response.data.refresh_token);

          console.log("LoginView: access_token:=" ,response.data.access_token)
          console.log("LoginView: refresh_token:=" ,response.data.refresh_token)

          // 사용자 프로필 저장
          await userStore.fetchUserProfile();

          console.log("After FeatchUser Profile")

          console.log("Current route:", router.currentRoute.value.path);

          //ElMessage.success("Kakao login successful!");
          router.push("/dashboard");

          console.log("After rouger.pus. Dashboard")

        } catch (error) {
          ElMessage.error("Failed to login with Kakao.");
          router.push("/login");
        }

      }
    });
  </script>
  
  <style scoped>
  .callback-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  </style>
  